import React from "react";
import {visualizeWithFilters} from "../api/api";
import {DefaultProps, RefTable} from "./RefTable";
import {MapToFilter} from "../utils/mappings";

export const PaginatedAuditTrail = (props)=><RefTable {...props}/>;

const AuditTrailLoad = async (tableName, filters = {}, page = {})=>{
    const _filters = MapToFilter(filters)
    return await visualizeWithFilters("audit_trail", {
        tableName: 'audit_log',
        filter:[..._filters],
        page: { size: page.size || 100, from: ((page.current || 1) - 1) * (page.size || 100)},
        orderBy: ['started desc']
    }) || {}
};

PaginatedAuditTrail.defaultProps = {
    ...DefaultProps,
    title: "Audit Trail",
    tableSchema: "audit_trail",
    tableName: "audit_log",
    filterSchema:"audit_trail_filter",
    edit: false,
    add: false,
    theadHeight: 40,
    tfootHeight: 50,
    fetch: AuditTrailLoad
}
